export const GET_MOVIE_CONFIG = 'GET_MOVIE_CONFIG';

export const GET_TRENDING_MOVIES_START = 'GET_TRENDING_MOVIES_START';
export const GET_TRENDING_MOVIES_SUCCESS = 'GET_TRENDING_MOVIES_SUCCESS';
export const GET_TRENDING_MOVIES_FAILURE = 'GET_TRENDING_MOVIES_FAILURE';

export const GET_MOVIE_GENRES_START = 'GET_MOVIE_GENRES_START';
export const GET_MOVIE_GENRES_SUCCESS = 'GET_MOVIE_GENRES_SUCCESS';
export const GET_MOVIE_GENRES_FAILURE = 'GET_MOVIE_GENRES_FAILURE';

export const GET_NOW_PLAYING_START = 'GET_NOW_PLAYING_START';
export const GET_NOW_PLAYING_SUCCESS = 'GET_NOW_PLAYING_SUCCESS';
export const GET_NOW_PLAYING_FAILURE = 'GET_NOW_PLAYING_FAILURE';

export const GET_UPCOMING_START = 'GET_UPCOMING_START';
export const GET_UPCOMING_SUCCESS = 'GET_UPCOMING_SUCCESS';
export const GET_UPCOMING_FAILURE = 'GET_UPCOMING_FAILURE';

export const GET_POPULAR_MOVIES_START = 'GET_POPULAR_MOVIES_START';
export const GET_POPULAR_MOVIES_SUCCESS = 'GET_POPULAR_MOVIES_SUCCESS';
export const GET_POPULAR_MOVIES_FAILURE = 'GET_POPULAR_MOVIES_FAILURE';

export const GET_MOVIE_DETAILS_START = 'GET_MOVIE_DETAILS_START';
export const GET_MOVIE_DETAILS_SUCCESS = 'GET_MOVIE_DETAILS_SUCCESS';
export const GET_MOVIE_DETAILS_FAILURE = 'GET_MOVIE_DETAILS_FAILURE';

export const GET_MOVIE_CAST_START = 'GET_MOVIE_CAST_START';
export const GET_MOVIE_CAST_SUCCESS = 'GET_MOVIE_CAST_SUCCESS';
export const GET_MOVIE_CAST_FAILURE = 'GET_MOVIE_CAST_FAILURE';

export const GET_MOVIE_REVIEW_START = 'GET_MOVIE_REVIEW_START';
export const GET_MOVIE_REVIEW_SUCCESS = 'GET_MOVIE_REVIEW_SUCCESS';
export const GET_MOVIE_REVIEW_FAILURE = 'GET_MOVIE_REVIEW_FAILURE';

export const GET_DISCOVER_MOVIES_START = 'GET_DISCOVER_MOVIES_START';
export const GET_DISCOVER_MOVIES_SUCCESS = 'GET_DISCOVER_MOVIES_SUCCESS';
export const GET_DISCOVER_MOVIES_FAILURE = 'GET_DISCOVER_MOVIES_FAILURE';

export const GET_SEARCH_MOVIES_START = 'GET_SEARCH_MOVIES_START';
export const GET_SEARCH_MOVIES_SUCCESS = 'GET_SEARCH_MOVIES_SUCCESS';
export const GET_SEARCH_MOVIES_FAILURE = 'GET_SEARCH_MOVIES_FAILURE';

export const GET_REQUEST_TOKEN_START = 'GET_REQUEST_TOKEN_START';
export const GET_REQUEST_TOKEN_SUCCESS = 'GET_REQUEST_TOKEN_SUCCESS';
export const GET_REQUEST_TOKEN_FAILURE = 'GET_REQUEST_TOKEN_FAILURE';

export const GET_SESSIONID_START = 'GET_SESSIONID_START';
export const GET_SESSIONID_SUCCESS = 'GET_SESSIONID_SUCCESS';
export const GET_SESSIONID_FAILURE = 'GET_SESSIONID_FAILURE';